import request from '@/utils/request'

export function getDashboardData(data) {
  return request({
    url: 'get/dashboard/data',
    method: 'post',
    params: data
  })
}

export function getSalesTrend(data) {
  return request({
    url: 'get/sales/trend',
    method: 'post',
    params: data
  })
}

// Phase 5: Statistics Reports
export function getDeviceSalesStats(data) {
  return request({
    url: 'report/get/device/sales',
    method: 'post',
    params: data
  })
}

export function exportOrdersCsv(data) {
  return request({
    url: 'report/export/csv',
    method: 'post',
    params: data,
    responseType: 'blob',
  })
}

export function getChallengeSummary(data) {
  return request({
    url: 'report/get/challenge/summary',
    method: 'post',
    params: data
  })
}

export function getRetryStats(data) {
  return request({
    url: 'report/get/retry/stats',
    method: 'post',
    params: data
  })
}

export function getGuaranteeGifts(data) {
  return request({
    url: 'report/get/guarantee/gifts',
    method: 'post',
    params: data
  })
}

export function getDisputeStats(data) {
  return request({
    url: 'report/get/dispute/stats',
    method: 'post',
    params: data
  })
}

// 汇总报表（按设备维度汇总收入/出币等）
export function getSumReports(data) {
  return request({
    url: 'report/get/sumreports',
    method: 'post',
    params: data
  })
}

// 今日收入明细
export function getTodayIncomes(data) {
  return request({
    url: 'report/get/today/incomes',
    method: 'post',
    params: data
  })
}

// 最新订单流
export function getNewestOrder(data) {
  return request({
    url: 'report/get/newest',
    method: 'post',
    params: data
  })
}

// 商户销售排行
export function getMerchantSalesRanking(data) {
  return request({
    url: 'report/merchant/ranking',
    method: 'post',
    params: data
  })
}

// 按天分类收入趋势（直购/挑战/充值）
export function getDailyCategoryBreakdown(data) {
  return request({
    url: 'report/get/daily/category/breakdown',
    method: 'post',
    params: data
  })
}

// 直购出奖记录
export function getDirectGifts(data) {
  return request({
    url: 'report/get/direct/gifts',
    method: 'post',
    params: data
  })
}

// 挑战订单明细
export function getChallengeOrders(data) {
  return request({
    url: 'report/get/challenge/orders',
    method: 'post',
    params: data
  })
}

// 纠纷明细记录
export function getDisputeRecords(data) {
  return request({
    url: 'report/get/dispute/records',
    method: 'post',
    params: data
  })
}

// 商户订单流水（设备订单流水弹窗用）
export function getMerchantOrders(data) {
  return request({
    url: 'report/get/merchant/orders',
    method: 'post',
    params: data
  })
}

// 按 deliver_id 查设备日报（含已解绑设备）
export function getDeliverBoardDailyReports(data) {
  return request({
    url: 'report/get/deliver/board/dailyreports',
    method: 'post',
    params: data
  })
}

// 全店铺按天汇总
export function getAllShopsDailyReports(data) {
  return request({
    url: 'report/get/allshops/dailyreports',
    method: 'post',
    params: data
  })
}

// 积分报表概览
export function getPointsReport(data) {
  return request({
    url: 'report/get/points/overview',
    method: 'post',
    params: data
  })
}

// 积分充值记录明细
export function getPointsRechargeRecords(data) {
  return request({
    url: 'report/get/points/recharge/records',
    method: 'post',
    params: data
  })
}

// 积分消耗记录明细
export function getPointsConsumeRecords(data) {
  return request({
    url: 'report/get/points/consume/records',
    method: 'post',
    params: data
  })
}
